import { render, staticRenderFns } from "./WeekFastNewsList.vue?vue&type=template&id=afcf9410&scoped=true"
import script from "./WeekFastNewsList.vue?vue&type=script&lang=js"
export * from "./WeekFastNewsList.vue?vue&type=script&lang=js"
import style0 from "./WeekFastNewsList.vue?vue&type=style&index=0&id=afcf9410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcf9410",
  null
  
)

export default component.exports